function initializeProduct(section) {
  if (section.dataset.initialized) return;
  section.dataset.initialized = 'true';
  const mainImage = section.querySelector('.product-gallery-main img');
  const select = section.querySelector('[data-variant-select]');
  const setImage = (src, alt) => {
    if (!mainImage || !src) return;
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.src = src;
    mainImage.alt = alt || '';
  };
  section.querySelectorAll('[data-gallery-src]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0 || !mainImage) return;
      event.preventDefault();
      setImage(link.dataset.gallerySrc, link.dataset.galleryAlt);
      section.querySelectorAll('[data-gallery-src]').forEach(item => item.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'true');
    });
  });
  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (!option) return;
    section.querySelector('[data-variant-price]').textContent = option.dataset.price;
    const button = section.querySelector('[data-add-button]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
    const quantity = section.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min || '1';
    quantity.step = option.dataset.step || '1';
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    setImage(option.dataset.image, option.dataset.imageAlt);
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
}
function initialize(scope = document) {
  scope.querySelectorAll('[data-product-section]').forEach(initializeProduct);
}
initialize();
document.addEventListener('shopify:section:load', event => initialize(event.target));
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('header details[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
document.addEventListener('click', event => {
  document.querySelectorAll('header details[open]').forEach(menu => {
    if (!menu.contains(event.target)) menu.open = false;
    else if (event.target.closest('a')) menu.open = false;
  });
});
